export default {
  title: 'Kuittien tulostus',
  sections: {
    destination: 'Kuitit tulostuvat',
  },
  printers: {
    inner: {
      title: 'Sisäinen tulostin',
    },
    external: {
      title: 'Ulkoinen tulostin',
      width_unset: 'Paperin leveyttä ei asetettu',
      connect_hint: 'Liitä tulostin käyttääksesi sitä',
      disconnect_confirm: 'Katkaise tulostimen yhteys?',
      disconnect_confirm_description: 'Joudut asettamaan sen uudelleen.',
      disconnect_confirm_ok: 'Kyllä, katkaise yhteys',
    },
  },
  // One block per printer state. `label` is the printer row's sub-line segment;
  // `title` and `description` are the status alert. `{{name}}` is the printer's name.
  statuses: {
    connected: {
      label: 'Valmis',
      title: 'Valmis tulostamaan',
      description: '{{name}}',
    },
    paper_near_end: {
      label: 'Paperi vähissä',
      title: 'Paperi on melkein lopussa',
      description: 'Vaihda rulla pian. Tulostus jatkuu.',
    },
    busy: {
      label: 'Varattu',
      title: 'Tulostin on varattu',
      description: '{{name}} viimeistelee toista työtä.',
    },
    not_configured: {
      label: 'Ei asetettu',
      title: 'Ei asetettu',
      description: '{{name}} täytyy asettaa ennen tulostusta.',
    },
    offline: {
      label: 'Offline',
      title: 'Ei tulosta',
      description: '{{name}} on offline. Uusia tilauksia ei tulosteta.',
      // Used when auto-print is off — nothing is silently failing to print.
      title_idle: 'Offline',
      description_idle: '{{name}} ei ole yhdistetty.',
    },
    cover_open: {
      label: 'Kansi auki',
      title: 'Kansi on auki',
      description: 'Sulje tulostimen kansi jatkaaksesi tulostusta.',
    },
    paper_empty: {
      label: 'Paperi loppu',
      title: 'Paperi loppu',
      description: 'Vaihda rulla jatkaaksesi tulostusta.',
    },
    wrong_paper: {
      label: 'Väärä paperi',
      title: 'Väärä paperi',
      description: 'Ladattu rulla ei vastaa asetettua paperin leveyttä.',
    },
    cutter_error: {
      label: 'Leikkurivirhe',
      title: 'Leikkurivirhe',
      description: 'Tarkista leikkuri paperitukoksen varalta ja yritä uudelleen.',
    },
    overheat: {
      label: 'Liian kuuma',
      title: 'Tulostin liian kuuma',
      description: 'Anna {{name}} jäähtyä ennen uutta tulostusta.',
    },
    error: {
      label: 'Virhe',
      title: 'Tulostinvirhe',
      description: '{{name}} ilmoitti virheestä ja tarvitsee huomiota.',
    },
    connecting: {
      label: 'Yhdistetään…',
      title: 'Yhdistetään…',
      description: '{{name}}',
    },
    disconnected: {
      label: 'Ei yhdistetty',
      title: 'Ei yhdistetty',
      description: '{{name}} ei ole yhdistetty.',
    },
  },
  form: {
    auto_print: {
      label: 'Tulosta uudet tilaukset automaattisesti',
      not_ready: 'Automaattitulostus on päällä, mutta ulkoinen tulostin ei ole valmis. Tilauksia ei tulosteta.',
    },
    print_copies: {
      label: 'Kopioita per tilaus',
      hint: 'Ota automaattitulostus käyttöön asettaaksesi kopiot',
      decrease: 'Vähennä kopioita',
      increase: 'Lisää kopioita',
    },
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallennus epäonnistui',
  },
  buttons: {
    test_print: 'Testituloste',
    configure_external: 'Määritä',
    connect_external: 'Liitä tulostin',
    disconnect_external: 'Katkaise yhteys',
    retry_connection: 'Yritä yhdistää uudelleen',
    cancel: 'Peruuta',
  },
};
